import { render, staticRenderFns } from "./userTemplatesDataInEntityProfile.vue?vue&type=template&id=94a834e6&scoped=true"
import script from "./userTemplatesDataInEntityProfile.vue?vue&type=script&lang=js"
export * from "./userTemplatesDataInEntityProfile.vue?vue&type=script&lang=js"
import style0 from "./userTemplatesDataInEntityProfile.vue?vue&type=style&index=0&id=94a834e6&prod&lang=scss&scoped=true"
import style1 from "./userTemplatesDataInEntityProfile.vue?vue&type=style&index=1&id=94a834e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a834e6",
  null
  
)

export default component.exports